/*
 * Login Messages
 *
 * This contains all the text for the login component.
 */
import { defineMessages } from 'react-intl';

export const scope = 'Taco.eula';

export default defineMessages({
  understand: {
    id: `${scope}.components.form.submit.understand`,
    defaultMessage: 'Client understands and agrees',
  },
  creditCardEulaTitle: {
    id: `${scope}.components.creditCardEula.title`,
    defaultMessage: 'Payment Terms & Conditions',
  },
  version: {
    id: `${scope}.components.form.submit.version`,
    defaultMessage: 'Revised version',
  },
  agreement: {
    id: `${scope}.components.form.submit.agreement`,
    defaultMessage: 'I have read the agreement.',
  },
  accept: {
    id: `${scope}.components.form.submit.accept`,
    defaultMessage: 'Accept',
  },
  tryAgain: {
    id: `${scope}.components.form.submit.tryAgain`,
    defaultMessage: 'Try again',
  },
  decline: {
    id: `${scope}.components.form.submit.decline`,
    defaultMessage: 'Decline',
  },
  declineContent: {
    id: `${scope}.components.form.submit.decline.content`,
    defaultMessage: 'Please accept EULA to continue.',
  },
  loadingTip: {
    id: `${scope}.loadingTip`,
    defaultMessage: 'Getting EULA data. Please wait...',
  },
  loadingRivirTCTip: {
    id: `${scope}.loadingTip`,
    defaultMessage: 'Getting RIVIR T&C data. Please wait...',
  },
  cannotGetEula: {
    id: `${scope}.cannotGetEula`,
    defaultMessage: 'Cannot get EULA data.',
  },
  cannotAcceptEula: {
    id: `${scope}.cannotAcceptEula`,
    defaultMessage: 'Cannot accept EULA',
  },
  creditCardDeclineMessage: {
    id: `${scope}.creditCard.decline.message`,
    defaultMessage:
      'Are you sure you want to decline Payment Terms & Conditions?',
  },
  creditCardDeclineOkBtn: {
    id: `${scope}.creditCard.decline.button.ok`,
    defaultMessage: 'Decline',
  },
  creditCardDeclineCancelBtn: {
    id: `${scope}.creditCard.decline.button.cancel`,
    defaultMessage: 'Try again',
  },
});
